import React, { useEffect } from 'react'
import CustomTitle from '../../components/UI/title/CustomTitle'
import MyButtonWhite from '../../components/UI/button/MyButtonWhite'
import { useDispatch, useSelector } from 'react-redux';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import VideoTemplateContent from './VideoTemplateContent';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClickNot, setIconButtonNot, setIsShowButtonNot, setTextButtonNot } from '../../store/buttonNotSlice';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';

export default function VideoTemplate({ img, title, text, queryName, video, id, eventName }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Add to plan'));
        dispatch(setIconButton('Tick'));

        dispatch(setIsShowButtonNot(true));
        dispatch(setTextButtonNot('Maybe later'));
        dispatch(setIconButtonNot('not'));
    }, []);

    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const buttonNotClicked = useSelector((state) => state.buttonNot.buttonClicked);
    const {trackP1Event} = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            queryParams.set(queryName, 1);
            trackP1Event(eventName, {
                user_response:  'Add to plan'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    useEffect(() => {
        if (buttonNotClicked) {
            dispatch(setButtonClickNot(false));
            trackP1Event(eventName, {
                user_response:  'Maybe later'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonNotClicked, dispatch]);

    const handleClickLater = () => {
        history.push(nextPage);
    }



    return (
        <div className="page page--with-notButton">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '12rem' }}
                        title={title}
                    />
                    <p className="text" style={{ marginBottom: '24rem' }}>{text}</p>
                    <VideoTemplateContent img={img} video={video} id={id}/>
                </div>

            </PageContent>

        </div>
    )
}
